module.exports = __webpack_public_path__ + "static/media/banner-1.cd637aa0.png";